import { render, staticRenderFns } from "./studentfeedback.vue?vue&type=template&id=371e7733&scoped=true"
import script from "./studentfeedback.vue?vue&type=script&lang=js"
export * from "./studentfeedback.vue?vue&type=script&lang=js"
import style0 from "./studentfeedback.vue?vue&type=style&index=0&id=371e7733&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e7733",
  null
  
)

export default component.exports